import { action } from "satcheljs";
import { IShiftRequestEntity } from "sh-models";

const declineSwapHandoffRequest = action(
    "DECLINE_SWAP_HANDOFF_REQUEST",
    (
        shiftRequest: IShiftRequestEntity,
        isReceiver: boolean,
        responseMessage: string,
        onFinish?: VoidFunction
    ) => ({
        shiftRequest: shiftRequest,
        isReceiver: isReceiver,
        responseMessage: responseMessage,
        onFinish: onFinish
    })
);

export default declineSwapHandoffRequest;
